import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const FormContainer = styled.div`
  width: 100%;
  height: auto;
  background: transparent;

`;

export const Card = styled.div`
  width: 100%;
  height: auto;
  max-width: 880px;
  padding: 24px;
  
  gap: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 20px auto 20px;
  
  border-radius: 8px;
  background-color: #FFF;
  border: 2px solid #F3F3F5;

  h2 {
    font-family: Lato;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #303848;
    position: absolute;
    top: 24px;
    margin: auto;
    left: 50%;
    margin-left: -75px;
  }


  @media only screen and (max-width: 1024px) {
    /* width: 100%;
    height: auto;
    margin: 20px 0px 20px;
    padding: 57px 50px 10px; */
  }

  @media only screen and (max-width: 780px) {
    width: 100%;
    margin-bottom: 0;
    //margin-top: -40px;
    padding: 57px 16px 10px;

  }
`;

export const ContainerSelectsAndButtons = styled.div`
  width: 100%;
  height: auto;

  gap: 8px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Row = styled.div`
  width: 100%;
  padding-left: 50px;
  padding-right: 60px;

  gap: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: ${props => (props.openBox ? 'flex-start' : 'center')};

  border: ${props => (props.isBorder ? 'solid 1px #e8edf3' : 'none')};
  border-radius: ${props => (props.isBorder ? '10px' : '0px')};
  
  transition: all 0.2s;

  .selectValue{
    width: 100%;
    height: 50px;
    max-width: 336px;

    display: flex;
    flex-direction: column;

    @media (max-width: 991px) {
      max-width: 277px;
    }

    @media (max-width: 760px) {
      max-width: 100%;
    }
  }

  @media only screen and (max-width: 780px) {
    flex-direction: column;
    padding-left: 0px;
    padding-right: 0px;
    
    /* .selectValue{
      width: 97%;
      height: 50px;
    } */
  }
`;

export const RowCard = styled.div`
  width: 100%;
  /* max-width: 700px; */
  max-height: ${props => (props.maxHeight ? props.maxHeight : '550px')};
  height: ${props => (props.height ? props.height : props.openBox ? '550px' : 'auto')};
  padding: ${props => (props.openBox ? '24px 24px 20px 24px' : '24px 22px 24px')};

  /* margin: auto; */

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: ${props => (props.openBox ? 'flex-start' : 'center')};
  
  background: white;
  border: ${props => (props.isBorder ? props.erro ? 'solid 2px #ff5252' : props.inativo ? `solid 2px ${theme.colors.disabled.Fundo_Desabilitado}` : 'solid 2px #e8edf3' : 'none')};
  border-radius: ${props => (props.isBorder ? '10px' : '0px')};

  transition: all 0.2s;

  .selectValue{
    width: 100%;
    height: 50px;
    max-width: 336px;

    display: flex;
    flex-direction: column;

    @media (max-width: 991px) {
      max-width: 277px;
    }

    @media (max-width: 760px) {
      max-width: 100%;
    }
  }

  .align {
    display: flex;                            
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .cancel {
    /* 20px, quadrado: o PNG de origem e 96x96, entao os 15x17 anteriores ainda
       distorciam um pouco a imagem. */
    width: 20px;
    height: 20px;
    margin-top: ${props => (props.openBox ? '0px' : '0px')};
    transition: all 0.2s;
    
    &:hover {
      cursor: pointer;
      transform: scale(1.2);
    }
    &:active {
      transform: scale(0.8);
    }
  }

  @media only screen and (max-width: 780px) {
    height: auto;
    /* padding: ${props => (props.openBox ? '45px 24px 40px 24px' : '45px 24px 40px 24px')}; */
    padding: 22px 8px 20px 8px;

    .align {
      height: 146px !important;
      display: flex;                            
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      padding-bottom: 10px;
    }
    .selectValue{
      width: 100%;
      height: 65px;
    }

    .cancel {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .arrow {
      transform: ${props => (!props.openBox ? 'none' : 'rotate(180deg)')};
      margin-top: ${props => (!props.openBox ? '-10px' : '0px')};
      
      position: ${props => props.openBox ? 'relative' : 'initial'};
      /* bottom: ${props => props.openBox ? '-358px' : '0px'}; */
      transition: all 0.2s;

      

      &:hover {
        cursor: pointer;
        transform: ${props => (!props.openBox ? 'scale(1.2) rotate(0deg)' : 'scale(1.2) rotate(180deg)')};
      }

      &:active {
        transform: scale(0.8);
      }
    }
  }
`;

export const ContainerImageCard = styled.div`
  width: 25px;
  height: 25px;

  display: flex;
  align-items: center;
  justify-content: center;

  .checked {
    width: 20px;
    height: auto;

    margin-left: ${props => (!props.openBox ? '-1px' : '-3px')};;
  }

  .arrow {
    width: 20px;
    height: auto;

    transform: ${props => (!props.openBox ? 'none' : 'rotate(180deg)')};
    margin-top: 0px;
    transition: all 0.2s;

    &:hover {
      cursor: pointer;
      transform: ${props => (!props.openBox ? 'scale(1.2) rotate(0deg)' : 'scale(1.2) rotate(180deg)')};
    }

    &:active {
      transform: scale(0.8);
    }
  }
`

export const ContainerInputsSelects = styled.div`
  width: 100%;
  height: auto;
  padding: 16px 0;
  
  gap: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 760px) {
    max-width: 336px;
    flex-direction: column;
  }
`;

export const ContainerInputsAndButtons = styled.div`
  width: 100%;
  height: auto;
  padding-bottom: ${(props) => props.openRelation ? "24px" : ""};
  
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  
  border-bottom: ${(props) => props.openRelation ? 'solid 2px #e8edf3' : 'solid 0px #e8edf3'};
`;

export const ContainerInputsSelect = styled.div`
  width: 100%;
  height: auto;
  max-width: 700px;

  gap: 16px;
  display: flex;
  justify-content: center;

  @media (max-width: 760px) {
    max-width: 336px;
    
    gap: 0px;
    align-items: center;
    flex-direction: column;
  }
`;

export const ButtonAddNewProduct = styled.button`
  all: unset;

  width: auto;
  height: auto;
  padding: ${props => (props.padding ? props.padding  : '12px')};

  gap: 8px;
  display: flex;
  justify-content: center;

  cursor: pointer;

  >img{
    width: 16px;
    height: auto;
  }
`;

export const ContainerRelationOptions = styled.div`
  width: 100%;
  height: 500px;
  padding-right: 170px;
  padding-left: 170px;
  padding-top: 30px;

  display: flex;
  flex-direction: column;

  margin-top: 3px;
  overflow-y: scroll;

  @media only screen and (max-width: 990px) {
    padding-right: 120px;
    padding-left: 120px;
  }
  

  @media only screen and (max-width: 780px) {
    padding-right: 15%;
    padding-left: 15%;
  }
  
  @media only screen and (max-width: 479px) {
    padding-right: 5%;
    padding-left: 5%;
  }
  
  @media only screen and (max-width: 380px) {
    padding-right: 5px;
    padding-left: 5px;
  }

  /* width */
  ::-webkit-scrollbar {
  width: 6px;

  
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 8px;
  
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
`;

export const ContainerInfoRevenuesByStates = styled.div`
  width: auto;
  height: auto;
  padding: 5px 8px;

  display: flex;

  border-radius: 5rem;
  background-color: ${theme.colors.gray.Cinza_12};

  >p {
    text-align: center;
  }

  >p > b{
    font-weight: ${theme.typography.fontWeight.extraBold};
  }
`;

export const Help = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  .help-buttom{
    margin-top: -40px;
    margin-right: -85px;
    
    color: #589bff;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;

    font-family: "Lato", Sans-serif;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2px;
    fill: #589bff;
    color: #589bff;
    background-color: #FFFFFF00;
    border-radius: 50px 50px 50px 50px;
    padding: 7px 12px 7px 12px;
    transition: all 0.2s;

    &:hover{
      transform: scale(1.1);
    }
  }

  @media only screen and (max-width: 990px) {
    .help-buttom{
      margin-right: -35px;
    }
  }
  @media only screen and (max-width: 780px) {
    .help-buttom{
      margin-right: -10px;
    }
  }
`;

export const Dispensed = styled.p`
  width: auto;
  height: 25px;
  border-radius: 5px;
  background-color: #f3f3f5;
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  color: ${theme.colors.red.Vermelho_erro};
  margin-right: 25px;
  padding: 4px;
  position: absolute;
  margin-top: 100px;

  @media only screen and (max-width: 796px) {
    margin-right: 0px;
    margin-top: 203px;

  }
`;

export const TableRowCellSmall = styled.div`
    width: auto;
    height: 35px;
    padding: 7px 10px;
    min-width: ${props => props.minWidth ? props.minWidth : 'auto'};

    margin-top: 8px;
    display: flex;
    align-items: center;

    border-radius: 10rem;
    background-color: ${theme.colors.gray.Cinza_12};

    >span{
      white-space: nowrap;
    }
`